import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=180aab0a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180aab0a')) {
      api.createRecord('180aab0a', component.options)
    } else {
      api.reload('180aab0a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=180aab0a&", function () {
      api.rerender('180aab0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i84b91DXDHi0/JS/comp/IncreaseNumber.vue"
export default component.exports